export default {
    'de': {
        short: {
            year: 'numeric', month: 'numeric', day: 'numeric'
        },
        long: {
            year: 'numeric', month: 'long', day: 'numeric',
            weekday: 'long', hour: 'numeric', minute: 'numeric',
            hour12: false
        },
        table: {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: 'numeric', minute: 'numeric', hour12: false
        }
    },
    'en': {
        short: {
            year: 'numeric', month: 'short', day: 'numeric'
        },
        long: {
            year: 'numeric', month: 'short', day: 'numeric',
            weekday: 'short', hour: 'numeric', minute: 'numeric'
        },
        table: {
            year: 'numeric', month: 'numeric', day: 'numeric',
            hour: 'numeric', minute: 'numeric'
        }
    },
    'it': {
        short: {
            year: 'numeric', month: 'long', day: 'numeric'
        },
        long: {
            year: 'numeric', month: 'long', day: 'numeric',
            weekday: 'long', hour: 'numeric', minute: 'numeric',
            hour12: false
        },
        table: {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: 'numeric', minute: 'numeric', hour12: false
        }
    }
}